module.exports = __webpack_public_path__ + "exo-latin-700italic.36b975e60be97473a1e6.woff2";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-700italic.woff2
// module id = ../../../../typeface-exo/files/exo-latin-700italic.woff2
// module chunks = styles